import {
  PaperPaymentItem,
  PaperPaymentItemBatch,
} from "../receipt-page-models/PaperPaymentItem";
import { mockUtils } from "../../../development/mocks/mock-utils";
import {
  getRandomMemberFromString,
  memberFromArray,
  numberFromString,
} from "../../events-screen/parent-events-mocks/mock-utils-functions";
import { PaperPaymentType } from "../receipt-page-models/PaperPaymentType";
import { Epoc } from "../../../_models/Epoc";

const amountsToPay = [50, 80, 120, 150, 160, 180, 200, 250, 400, 500];
const paymentDates: Epoc[] = [
  1763918933, 1778830422, 1781957397, 1781957707, 1782360444,
] as Epoc[];
const createSinglePaymentItem = (hash: string): PaperPaymentItem => {
  const childName =
    getRandomMemberFromString(`c${hash}`, mockUtils.hebFirstNames) +
    " " +
    getRandomMemberFromString(`c${hash}`, mockUtils.hebLastNames);
  const amountToPay = getRandomMemberFromString(
    `amount${childName}`,
    amountsToPay
  );
  return {
    receiptNumber: "",
    personWhoDeposited: "",
    paymentType: PaperPaymentType.cash,
    receiptUrl: "",
    eventName: "",
    refundRequested: false,
    receiptDate: memberFromArray(paymentDates, childName) as Epoc,
    beyondDepositTimeframe: false,
    checkInfo: "" as any,
    id: Math.floor(Math.random() * 100000),
    childName,
    amountToPay,
    leftForDeposit: amountToPay,
    isPartiallyDeposit: Math.floor(Math.random() * 10) > 5,
  };
};

const createOnePaymentBatch = (num: number): PaperPaymentItemBatch => {
  const eventName = getRandomMemberFromString(
    `eventName${num}`,
    mockUtils.eventNames
  );
  const personWhoDeposited =
    getRandomMemberFromString(`p${num}${eventName}`, mockUtils.hebFirstNames) +
    " " +
    getRandomMemberFromString(`p${num}${eventName}`, mockUtils.hebLastNames);
  const childName =
    getRandomMemberFromString(`c${num}${eventName}`, mockUtils.hebFirstNames) +
    " " +
    getRandomMemberFromString(`c${num}${eventName}`, mockUtils.hebLastNames);
  const typeOfPayment = getRandomMemberFromString(
    `typeOfPayment${num}${eventName}`,
    [PaperPaymentType.cash, PaperPaymentType.check, PaperPaymentType.cash]
  );
  const daysAgo = getRandomMemberFromString(
    `daysAgo${num}${eventName}`,
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
  );

  const base: Partial<PaperPaymentItem> & { paymentsItems: any[] } = {
    id: numberFromString(personWhoDeposited + num, 100000),
    amountToPay: 300,
    childName,
    beyondDepositTimeframe: num === 3,
    paymentsItems: [] as any,
    leftForDeposit: 300,
    receiptDate: memberFromArray(
      paymentDates,
      `${daysAgo}${num}${eventName}`
    ) as Epoc,
    eventName,
    refundRequested: false,
    paymentType: typeOfPayment,
    personWhoDeposited,

    receiptUrl: "",
    receiptNumber: "",
  };
  const numberOfItems = getRandomMemberFromString(
    eventName,
    [1, 2, 3, 4, 5, 6]
  );
  const items: PaperPaymentItem[] = new Array(numberOfItems)
    .fill(0)
    .map((_, index) => {
      return {
        ...base,

        ...createSinglePaymentItem(`${num}${index}${eventName}`),
      };
    });

  if (
    numberOfItems === 1 &&
    typeOfPayment === PaperPaymentType.cash &&
    getRandomMemberFromString(`${eventName}zbc`, [
      "",
      "",
      "partiallyPaid",
      "partiallyPaid",
      "partiallyPaid",
      "",
    ]) === "partiallyPaid"
  ) {
    items[0].leftForDeposit = items[0].amountToPay - 30;
  }

  return {
    receiptDate: base.receiptDate,
    isPartiallyDeposit: base.isPartiallyDeposit,
    personWhoDeposited: base.personWhoDeposited,
    receiptNumber: base.receiptNumber,
    refundRequested: num === 1,
    receiptUrl: "",
    childName: "",
    eventName: "",
    paymentType: PaperPaymentType.cash,
    beyondDepositTimeframe: false,
    id: Math.floor(Math.random() * 100000),
    ...base,
    amountToPay: items.reduce((sum, item) => sum + item.amountToPay, 0),
    leftForDeposit: items.reduce((sum, item) => sum + item.leftForDeposit, 0),
    paymentsItems: [...items],
  };
};
// create array of numbers 1- 10

const paymentItemBatch: PaperPaymentItemBatch[] = new Array(40)
  .fill(0)
  .map((_, index) => createOnePaymentBatch(index + 1));
paymentItemBatch.shift();

export const receiptMockData = {
  main: paymentItemBatch,
};



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-util-mock/receipt-mock-data.ts